import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import type { WithSlots } from "types";
import { ReviewableInput } from "ui/widgets/Input";
import { OnboardingSelectedPaymentMethod } from "ui/molecules/PaymentMethod";
import { Collection } from "ui/support/Resource";
import { OnboardingForm, OnboardingReviewableFormInput } from "ui/forms/Onboarding/shared";
import {
    FormField,
    type PaymentMethod as PaymentMethodType,
    type OnboardingPaymentMethodsProps
} from "./types";

export const PaymentMethods = ({
    values,
    isSubmitting,
    isValid,
    isBootstrapDataLoading,
    bootstrapData,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    handleSubmit,
    slots,
    ...form
}: WithSlots<
    OnboardingPaymentMethodsProps,
    {},
    {
        readonly otherMethods: ReactNode;
    }
>) => (
    <OnboardingForm
        {...form}
        isSubmitting={isSubmitting}
        isValid={isValid}
        handleSubmit={handleSubmit}
    >
        <OnboardingReviewableFormInput
            sx={{
                alignItems: 'flex-start'
            }}
            name={FormField.Methods}
            values={values}
            renderLabel={() => 'Payment Methods'}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            slots={{
                actions: (
                    <>
                        <ReviewableInput.ApproveAction />
                        <ReviewableInput.RejectAction />
                        <ReviewableInput.CommentAction />
                    </>
                )
            }}
            renderFormInput={({ reviewableStatus }) => (
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto',
                        alignItems: 'flex-start',
                        gap: 1
                    }}
                >
                    <Collection
                        sx={{
                            display: 'grid',
                            gap: 2
                        }}
                        collection={bootstrapData.methods.filter(method => (
                            values[FormField.Methods]
                                .includes(method.tag)
                        ))}
                        renderResource={(paymentMethod: PaymentMethodType, index) => (
                            <OnboardingSelectedPaymentMethod
                                key={index}
                                {...paymentMethod}
                            />
                        )}
                    />
                    <Box
                        sx={{
                            mt: 1
                        }}
                    >
                        {reviewableStatus}
                    </Box>
                </Box>
            )}
        />
        {slots?.otherMethods}
    </OnboardingForm>
);

export default PaymentMethods;
